// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8e4cc44c4469aa09bfb0d2b2c8249908172bbe13.chunk.bundle.js";
};